export enum VoiceLanguage {
  English = "en",
  Spanish = "es",
}
